import {sortShiftPropertiesPrimaryFirst} from "./helpers";
import type {Shift, ShiftProperty} from "../types";

export function getShiftPrimaryProperty(
  shift: Shift | null | undefined,
): ShiftProperty | null {
  if (!shift?.properties?.length) {
    return null;
  }

  return sortShiftPropertiesPrimaryFirst(shift.properties)[0] ?? null;
}
